export default "varying vec3 pos;\n\nvoid main()\n{\n  pos = position;\n  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}\n"